/** First and last calendar day of the current month in local time, as YYYY-MM-DD. */
export function getCurrentMonthDateRangeLocal(): { startDate: string; endDate: string } {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth();
    const start = new Date(y, m, 1);
    const end = new Date(y, m + 1, 0);
    const pad = (n: number) => String(n).padStart(2, "0");
    const fmt = (d: Date) =>
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    return { startDate: fmt(start), endDate: fmt(end) };
}
